import { CircularProgress, makeStyles } from "@material-ui/core";
import React, { useState } from "react";

const useStyles = makeStyles((theme) => ({
  contentVert: {
    height: "650px",
    maxWidth: "450px",
    width: "70%",
    marginBottom: "70px",
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      height: "600px",
      width: "70%",
      marginBottom: "50px",
    },
    [theme.breakpoints.down("xs")]: {
      height: "550px",
      width: "75%",
      margin: "0 auto",
      marginBottom: "40px",
    },
  },
  videoWrapperVert: {
    display: "flex",
    height: "100%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
    borderRadius: "4px",
  },
  frameVert: {
    position: "relative",
    height: "650px",
    maxWidth: "450px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      height: "600px",
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      height: "550px",
      width: "100%",
    },
  },
  vidDescVert: {
    fontFamily: "Gordita Regular, Helvetica Neue, Helvetica, sans-serif",
    marginLeft: "30px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
  },
}));

// Takes two props videoLink and description

function VideoVert(props) {
  const [isLoading, setIsLoading] = useState(true);
  const classes = useStyles();
  return (
    <>
      <h3 className={classes.vidDescVert}>{props.description}</h3>
      <div className={classes.contentVert}>
        <div className={classes.videoWrapperVert}>
          {isLoading ? (
            <CircularProgress
              size={100}
              style={{
                position: "absolute",
              }}
            />
          ) : null}
          <iframe
            className={classes.frameVert}
            src={props.videoLink}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            onLoad={() => setIsLoading(false)}
          ></iframe>
        </div>
      </div>
    </>
  );
}

export default VideoVert;
